module.exports = __webpack_public_path__ + "files/e3a0f761ef65a4c2928a8047e012166a.svg";